module.exports = __webpack_public_path__ + "static/categories_defined-f2074445a6b904b4523aa20bbe0ffaee.png";